import { sendAjaxRequest, sendGETRequest } from "../API";
import { getContentURL, getSiteBaseURL, getUploadURL, } from "../ContentAPI";
import { authUrl } from "./UrlUtils";
import { clearRestoreURL } from "../Auth/AuthUtils";
/* TODO: Save for messaging
import {
  RsaImportableKey,
  RawRsaKeyringWebCrypto,
  buildClient,
  CommitmentPolicy,
} from '@aws-crypto/client-browser'

const { encrypt, decrypt } = buildClient(
  CommitmentPolicy.REQUIRE_ENCRYPT_REQUIRE_DECRYPT
)

const publicRsaJwkKey: RsaImportableKey = {
  alg: 'RSA-OAEP-256',
  e: 'AQAB',
  ext: true,
  key_ops: ['wrapKey'],
  kty: 'RSA',
  n: '6k_jrxg7mpz7CzgAr6eRqJr1VlvjJ9uQY71hadkDZkLLZHiMl7hz73lqq3w2MfHCa3Pf3BVo5TCXGYuxKOlPb7bH0WWpMeAzOKR_X27UqfA8MBVGb4YO5HXqw0jup8-I-Zi3CQAmP87uE6GDuh7xzeAcwpGD5xE0N74-uWq3YS92PFHCavtryx-ad9VGTgfAbkV3k1-RSxIiZjzbAt3exBAn5EjMfF6FMI70_HYqO-5xGv_aAPSa1OMc_buK5QACN7gmFwqHBzw98v93iyGUc4_XJNL-jPzKNP4AT1zMc6p6RxF3SYytNq7iXIjUmm-oY8fvCSmT1F13XKdzv7DLOw',
}

const privateKey = RawRsaKeyringWebCrypto.importPrivateKey(
  privateRsaJwKKey
)
const publicKey = RawRsaKeyringWebCrypto.importPublicKey(
  publicRsaJwkKey
)

const keyNamespace = 'HSM_01'
const keyName = 'RSA_2048_06'

const keyring = new RawRsaKeyringWebCrypto({
  keyName,
  keyNamespace,
  publicKey,
  privateKey,
})
*/
export const DATA_UTIL_CLIENT_OK = 20000;
export const DATA_UTIL_CLIENT_SKIP_IMAGE_UPLOAD = 20001;
export const DATA_UTIL_CLIENT_ERROR_MISSING_BEARER = 20002;
export const DATA_UTIL_CLIENT_ERROR_MISSING_SEQUENCE = 20003;
export const DATA_UTIL_CLIENT_ERROR_GET_IMAGE_URL_FAILED = 20004;
export const DATA_UTIL_CLIENT_ERROR_GET_JSON_URL_FAILED = 20005;
export const DATA_UTIL_CLIENT_ERROR_IMAGE_UPLOAD_FAILED = 20006;
export const DATA_UTIL_CLIENT_ERROR_DATA_UPLOAD_FAILED = 20007;
export const DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED = 20008;
export const DATA_UTIL_CLIENT_ERROR_DELETE_POST_FAILED = 20009;
export const DATA_UTIL_CLIENT_ERROR_ENCRYPTION_FAILED = 20010;
export const DATA_UTIL_CLIENT_ERROR_SAVE_DATA_FAILED = 20011;
export const DATA_UTIL_CLIENT_ERROR_SAVE_CHANNEL_TO_DATABASE_FAILED = 20012;
export const DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED_SESSION_EXPIRED = 20013;
export const SESSION_EXPIRED_ERROR_CODE = 999999;
export const CHANNEL_MEMBERSHIP_NOT_MEMBER = "not_member";
export const CHANNEL_MEMBERSHIP_MEMBER = "member";
export const CHANNEL_MEMBERSHIP_REQUESTED = "requested";
export const CHANNEL_MEMBERSHIP_DENIED = "denied";
const LOGPREFIX = "DataUtils: ";
export const saveChannelPost = (input, callbacks, cacheBusterStore, logger) => {
    cacheBusterStore.incrementCacheBuster();
    const bearer = callbacks.authCallback.bearer();
    if (!bearer) {
        logger.error(LOGPREFIX + "saveChannelPost: Missing access token.");
        callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_BEARER, "Missing access token.");
        return;
    }
    const sequence = callbacks.authCallback.sequence();
    if (!sequence) {
        logger.error(LOGPREFIX + "saveChannelPost: Missing access token sequence.");
        callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_SEQUENCE, "Missing access token sequence number.");
        return;
    }
    const step2OKCallback = (clientDetailCode) => {
        logger.log(LOGPREFIX + "DataUtils.step.2.a: ok - " + clientDetailCode);
        // Step 3 - Get Presigned URL to Put JSON Data
        const getUploadURLStep3Callback = (ok, status, response) => {
            // Step 3.b - Check Step 3 Results
            if (!ok) {
                // Step 3.b - Failed
                logger.log(LOGPREFIX + "DataUtils.step.3.b: failed - status = " + status);
                let errorMessage = "Unable to get data writer URL. (" + status + ").";
                let clientDetailCode = DATA_UTIL_CLIENT_ERROR_GET_JSON_URL_FAILED;
                if (response) {
                    if (response.error) {
                        errorMessage = response.error;
                    }
                    if (response.clientDetailCode) {
                        clientDetailCode = response.clientDetailCode;
                    }
                }
                checkForSessionExpiry(callbacks.authCallback.getAuth(), clientDetailCode, logger);
                callbacks.errorCallback(clientDetailCode, errorMessage);
                return;
            }
            else {
                // Step.3.b - Success
                logger.log(LOGPREFIX + "DataUtils.step.3.b: ok");
                const step4OKCallback = (clientDetailCode) => {
                    logger.log(LOGPREFIX + "DataUtils.step.4.a: ok - " + clientDetailCode);
                    callbacks.okCallback(DATA_UTIL_CLIENT_OK);
                };
                if (response) {
                    callbacks.authCallback.setBearerAndSequence(response.bearer, response.sequence);
                }
                logger.log(LOGPREFIX + "DataUtils.step.3.b: ok - url = " + (response === null || response === void 0 ? void 0 : response.url));
                const dataUploadUrl = response === null || response === void 0 ? void 0 : response.url;
                if (!dataUploadUrl) {
                    logger.error(LOGPREFIX +
                        "saveChannelPost: Unable to get data writer URL; missing result.");
                    callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_GET_JSON_URL_FAILED, "Unable to get data writer URL; missing result.");
                    return;
                }
                // Step.3.b. - Complete
                // Step 4 - Upload Application Data
                input.imageDataUrl = undefined;
                const data = JSON.stringify(input);
                uploadApplicationData(dataUploadUrl, data, step4OKCallback, (clientDetailCode, errorMessage) => {
                    logger.error(LOGPREFIX +
                        "DataUtils.step.4.a: failed - " +
                        clientDetailCode +
                        " " +
                        errorMessage);
                    checkForSessionExpiry(callbacks.authCallback.getAuth(), clientDetailCode, logger);
                    callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_DATA_UPLOAD_FAILED, "Failed to save data. " + errorMessage);
                    return;
                }, cacheBusterStore, logger);
                return;
            }
        };
        const bearer = callbacks.authCallback.bearer();
        if (!bearer) {
            logger.error(LOGPREFIX + "saveChannelPost: Missing access token.");
            callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_BEARER, "Missing access token.");
            return;
        }
        const sequence = callbacks.authCallback.sequence();
        if (!sequence) {
            logger.error(LOGPREFIX + "saveChannelPost: Missing access token sequence.");
            callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_SEQUENCE, "Missing access token sequence number.");
            return;
        }
        getUploadURL(getUploadURLStep3Callback, input.channelOwnerId, input.postId, "u/" + input.channelOwnerId + "/" + input.channelId, "json", bearer, sequence, cacheBusterStore);
    };
    step2OKCallback(DATA_UTIL_CLIENT_SKIP_IMAGE_UPLOAD);
};
export const saveChannelData = (input, callbacks, cacheBusterStore, logger) => {
    cacheBusterStore.incrementCacheBuster();
    const bearer = callbacks.authCallback.bearer();
    if (!bearer) {
        logger.error(LOGPREFIX + "saveChannelData: Missing access token.");
        callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_BEARER, "Missing access token.");
        return;
    }
    const sequence = callbacks.authCallback.sequence();
    if (!sequence) {
        logger.error(LOGPREFIX + "saveChannelData: Missing access token sequence.");
        callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_MISSING_SEQUENCE, "Missing access token sequence number.");
        return;
    }
    // Set lastUpdated timestamp before saving
    input.lastUpdated = Date.now();
    const path = "channel";
    const saveInput = {
        operation: "saveChannelData",
        channelOwnerId: input.channelOwnerId,
        channelId: input.channelId,
        channelData: {
            channelOwnerId: input.channelOwnerId,
            channelId: input.channelId,
            title: input.title,
            subtitle: input.subtitle,
            description: input.description,
            lastUpdated: input.lastUpdated,
            tempImagePath: input.tempImagePath,
            permissions: input.permissions,
            private: input.private,
            membershipPrompt: input.membershipPrompt,
        },
    };
    logger.log(LOGPREFIX + "saveChannelData: " + JSON.stringify(saveInput));
    const payload = saveInput;
    payload.sequence = sequence;
    const apiCallback = (ok, status, message) => {
        if (ok) {
            const result = JSON.parse(message);
            cacheBusterStore.incrementCacheBuster();
            if (result.bearer && result.sequence) {
                callbacks.authCallback.setBearerAndSequence(result.bearer, result.sequence);
            }
            logger.log(LOGPREFIX + "saveChannelData: Success - " + result.clientDetailCode);
            callbacks.okCallback(result.clientDetailCode);
        }
        else {
            logger.error(LOGPREFIX +
                "saveChannelData: Failed to save channel data. " +
                status +
                " " +
                message);
            callbacks.errorCallback(DATA_UTIL_CLIENT_ERROR_SAVE_CHANNEL_TO_DATABASE_FAILED, "Failed to save channel data. " + message);
        }
    };
    sendAjaxRequest(apiCallback, path, payload, bearer, cacheBusterStore, logger);
};
export const uploadApplicationData = (s3UploadUrl, data, okCallback, errorCallback, cacheBusterStore, logger) => {
    cacheBusterStore.incrementCacheBuster();
    logger.log(LOGPREFIX +
        "uploadApplicationData: uploadUrl = " +
        s3UploadUrl +
        ", data = " +
        data);
    const blob = new Blob([data], {
        type: "application/json",
    });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/octet-stream");
    const request = new Request(s3UploadUrl, {
        method: "PUT",
        body: blob,
        headers: myHeaders,
    });
    fetch(request)
        .then(function (res) {
        logger.log(LOGPREFIX + "uploadApplicationData: RESULT = " + JSON.stringify(res));
        // Check if the HTTP response was successful
        if (res.ok) {
            okCallback(DATA_UTIL_CLIENT_OK);
        }
        else {
            logger.error(LOGPREFIX +
                "uploadApplicationData: HTTP Error - Status: " +
                res.status +
                " " +
                res.statusText);
            errorCallback(DATA_UTIL_CLIENT_ERROR_DATA_UPLOAD_FAILED, "Failed to save data. HTTP " + res.status + ": " + res.statusText);
        }
    })
        .catch(function (err) {
        logger.error(LOGPREFIX + "uploadApplicationData: Network ERROR = " + err);
        errorCallback(DATA_UTIL_CLIENT_ERROR_DATA_UPLOAD_FAILED, "Failed to save data. " + err);
    });
};
export const loadChannelData = (partitionId, channelOwnerId, channelId, contentId, fileType, callbacks, auth, cacheBusterStore, logger) => {
    logger.log(LOGPREFIX + "loadChannelData");
    const path = authUrl(getContentURL() +
        "/" +
        partitionId +
        "/" +
        channelOwnerId +
        "/" +
        channelId +
        "/" +
        contentId +
        "." +
        fileType, cacheBusterStore, auth);
    logger.log(LOGPREFIX + "loadChannelData: path = " + path);
    loadChannelDataFromURL(path, callbacks, cacheBusterStore, logger);
};
export const loadChannelDataWithLocalCacheBuster = (partitionId, channelOwnerId, channelId, contentId, fileType, localCacheBuster, callbacks, auth, cacheBusterStore, logger) => {
    logger.log(LOGPREFIX +
        "loadChannelDataWithLocalCacheBuster: localCacheBuster = " +
        localCacheBuster);
    // Channel data JSON files are publicly accessible, no bearer token needed
    // Just add the local cache buster parameter
    const baseUrl = getContentURL() +
        "/" +
        partitionId +
        "/" +
        channelOwnerId +
        "/" +
        channelId +
        "/" +
        contentId +
        "." +
        fileType;
    const path = baseUrl + "?poll=" + localCacheBuster;
    logger.log(LOGPREFIX + "loadChannelDataWithLocalCacheBuster: path = " + path);
    loadChannelDataFromURL(path, callbacks, cacheBusterStore, logger);
};
export const loadChannelDataFromURL = (url, callbacks, cacheBusterStore, logger) => {
    logger.log(LOGPREFIX + "loadChannelDataFromURL: url = " + url);
    const apiCallback = (ok, status, message) => {
        logger.log(LOGPREFIX +
            "loadChannelDataFromURL: ok = " +
            ok +
            ", status = " +
            status +
            ", message = " +
            message);
        if (ok && status >= 200 && status < 300) {
            callbacks.okCallback(DATA_UTIL_CLIENT_OK, message);
        }
        else {
            let errorMessage = message
                ? message + " status " + status
                : "Request Failed - Status = " + status;
            let statusCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
            if (status == 401) {
                statusCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED_SESSION_EXPIRED;
                errorMessage = "Login Session Expired";
                clearRestoreURL();
            }
            logger.error(LOGPREFIX +
                "loadChannelDataFromURL: apiCallback ERROR = " +
                statusCode +
                " " +
                errorMessage);
            callbacks.errorCallback(statusCode, errorMessage);
        }
    };
    sendGETRequest(apiCallback, url, cacheBusterStore, logger);
};
export const channelOperation = (input, callbacks, authCallback, cacheBusterStore, logger) => {
    if (channelOperation.toString().startsWith("save") ||
        channelOperation.toString().startsWith("delete") ||
        channelOperation.toString().startsWith("set")) {
        cacheBusterStore.incrementCacheBuster();
    }
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "channelOperation: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "channelOperation: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            if (obj.bearer && obj.sequence) {
                logger.log(LOGPREFIX +
                    "channelOperation: apiCallback OK - bearer and sequence set");
                authCallback.setBearerAndSequence(obj.bearer, obj.sequence);
            }
            else {
                logger.log(LOGPREFIX +
                    "API response does NOT contain bearer and sequence - " +
                    message);
            }
            callbacks.okCallback(obj.clientDetailCode, message);
        }
        else {
            logger.error(LOGPREFIX +
                "channelOperation: apiCallback ERROR = " +
                status +
                " " +
                message);
            const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
            callbacks.errorCallback(clientDetailCode, message);
        }
    };
    const path = "channel";
    const payload = input;
    payload.sequence = authCallback.sequence();
    logger.log(LOGPREFIX + "channelOperation: " + JSON.stringify(payload));
    sendAjaxRequest(apiCallback, path, payload, authCallback.bearer(), cacheBusterStore, logger);
};
export const deletePost = (input, callbacks, authCallback, cacheBusterStore, logger) => {
    return channelOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const listChannelsByOwner = (input, callbacks, authCallback, cacheBusterStore, logger) => {
    return channelOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const deleteChannel = (input, callbacks, authCallback, cacheBusterStore, logger) => {
    return channelOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const checkForSessionExpiry = (auth, statusCode, logger) => {
    if (SESSION_EXPIRED_ERROR_CODE == statusCode) {
        logger.log(LOGPREFIX + "checkForSessionExpiry: Session Expired");
        auth.reset(logger);
        window.location.href = getSiteBaseURL() + "Login";
    }
};
export const contactOperation = (input, callbacks, cacheBusterStore, logger) => {
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "contactOperation: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "contactOperation: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            callbacks.okCallback(obj.clientDetailCode, message);
        }
        else {
            logger.error(LOGPREFIX +
                "contactOperation: apiCallback ERROR = " +
                status +
                " " +
                message);
            const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
            let messageStr = message;
            if (!messageStr) {
                messageStr = "Operation failed with status " + status + ".";
            }
            callbacks.errorCallback(clientDetailCode, messageStr);
        }
    };
    const path = "contact";
    const payload = input;
    logger.log(LOGPREFIX + "contactOperation: " + JSON.stringify(payload));
    sendAjaxRequest(apiCallback, path, payload, undefined, cacheBusterStore, logger);
};
export const studioOperation = (input, callbacks, authCallback, cacheBusterStore, logger) => {
    if (input.operation === "createJob" ||
        input.operation === "deleteJob" ||
        input.operation === "updateJobStatus") {
        cacheBusterStore.incrementCacheBuster();
    }
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "studioOperation: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "studioOperation: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            if (obj.bearer && obj.sequence) {
                logger.log(LOGPREFIX +
                    "studioOperation: apiCallback OK - bearer and sequence set");
                authCallback.setBearerAndSequence(obj.bearer, obj.sequence);
            }
            else {
                logger.log(LOGPREFIX +
                    "Studio API response does NOT contain bearer and sequence - " +
                    message);
            }
            callbacks.okCallback(obj.clientDetailCode, message);
        }
        else {
            logger.error(LOGPREFIX +
                "studioOperation: apiCallback ERROR = " +
                status +
                " " +
                message);
            const clientDetailCode = DATA_UTIL_CLIENT_ERROR_LOAD_DATA_FAILED;
            callbacks.errorCallback(clientDetailCode, message);
        }
    };
    const path = "studio";
    const payload = input;
    payload.sequence = authCallback.sequence() || 0;
    logger.log(LOGPREFIX + "studioOperation: " + JSON.stringify(payload));
    sendAjaxRequest(apiCallback, path, payload, authCallback.bearer(), cacheBusterStore, logger);
};
export const createStudioJob = (input, callbacks, authCallback, cacheBusterStore, logger) => {
    return studioOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const listStudioJobsByOwner = (callbacks, authCallback, cacheBusterStore, logger, startKey) => {
    const input = Object.assign({ operation: "listJobsByOwner", sequence: 0 }, (startKey && { startKey }));
    return studioOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const getStudioJob = (jobId, callbacks, authCallback, cacheBusterStore, logger) => {
    const input = {
        operation: "getJob",
        jobId: jobId,
        sequence: 0, // Will be set by studioOperation
    };
    return studioOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const deleteStudioJob = (jobId, callbacks, authCallback, cacheBusterStore, logger) => {
    const input = {
        operation: "deleteJob",
        jobId: jobId,
        sequence: 0, // Will be set by studioOperation
    };
    return studioOperation(input, callbacks, authCallback, cacheBusterStore, logger);
};
export const savePost = (input, callbacks, cacheBusterStore, logger) => {
    const apiCallback = (ok, status, message) => {
        if (ok) {
            try {
                const result = JSON.parse(message);
                callbacks.onSuccess(result);
            }
            catch (error) {
                logger.error("Failed to parse savePost response: " + error);
                callbacks.onError("Failed to parse server response");
            }
        }
        else {
            logger.error("SavePost failed: " + status + " " + message);
            callbacks.onError("Save failed: " + message);
        }
    };
    sendAjaxRequest(apiCallback, "content", input, input.bearer, cacheBusterStore, logger);
};
